module.exports = __webpack_public_path__ + "img/dsal_logo_black.a1300f70.png";